import React from 'react';
import PropTypes from 'prop-types';
import { SearchTag as SearchTagClass } from '../../utils/searchUtils';
import CloseIcon from '../../../icons/sub-menu-and-common-icons/close-icon.svg';
function SearchTag({ searchTag, onRemoveClick, onEditClick }) {
  const label = searchTag.label
    ? searchTag.label
    : `${searchTag.tagType}: ${searchTag.value}`;
  // only allow editing of search tags that present the search itself, and not a different label
  const isEditable =
    !searchTag.label ||
    (searchTag.label && searchTag.label === searchTag.value);
  const onKeyPress = (e) => {
    if (e.keyCode === 13) {
      e.target.blur();
      onEditClick(searchTag, e.target.textContent);
    } else if (e.keyCode === 27) {
      e.target.textContent = label;
      e.target.blur();
    }
  };

  return (
    <span className="search-tag">
      <span
        className="input search-tag__input font-xs-regular"
        contentEditable={isEditable}
        onKeyDown={onKeyPress}
        spellCheck={false}
        suppressContentEditableWarning
      >
        {label}
      </span>

      <img
        src={CloseIcon}
        className="search-tag__remove-icon"
        onClick={() => onRemoveClick(searchTag)}
      />
    </span>
  );
}

SearchTag.propTypes = {
  searchTag: PropTypes.instanceOf(SearchTagClass),
  onRemoveClick: PropTypes.func,
  onEditClick: PropTypes.func,
};

export default SearchTag;
